<div class="bottom-sheet-data-wrapper">
    <button class="drawer-close-btn mat-elevation-z0" mat-mini-fab aria-label="Close" (click)="dismiss()">
        <mat-icon>close</mat-icon>
    </button>
    <div class="bottom-sheet-data">
        <span class="ms-5 me-3"><span class="ms-5">{{getMessage()}}</span></span>
        <button (click)="delete()" class="common-button success min-width mat-elevation-z0 mx-1" mat-button mat-raised-button
            cdkFocusInitial>
            Yes
        </button>
        <button (click)="dismiss()" class="common-button black min-width mat-elevation-z0 mx-1" mat-button mat-raised-button>
            No
        </button>
    </div>
</div>